<template>
  <search-group title="商机查询" @search="findData" @clear="clearValue"
                :multipleLines="true" :inline="false" :span="24" :btnOffset="18" :btnSpan="6"
             >
    <Row :gutter="8" class="max64" style="margin-bottom: 16px;">
      <Col span="6">
        <Select v-model="searchData.projectFid" @on-change="changeProject" placeholder="请选择项目">
          <Option value="">请选择</Option>
          <Option value="100" v-for="item in projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="5">
        <Select v-model="searchData.zoFid" placeholder="请选择zo">
          <Option value="">{{searchData.projectFid==='' ? '请先选择项目':'请选择'}}</Option>
          <Option value="100" v-for="(item,i) in zoList" :value="item.value" :key="item.value+i">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="5">
        <Select v-model="searchData.handleStatus" placeholder="商机状态">
          <Option value="">请选择</Option>
          <Option value="100" v-for="item in statusList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="4" >
        <Select v-model="searchData.gradeList" @on-change="checkGradeAll" placeholder="商机等级" multiple>
          <Option value="all">全部选择</Option>
          <Option v-for="item in gradeList" :value="item.text" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="4">
        <Select v-model="searchData.businessFromPlatform" placeholder="来源平台">
          <Option value="">请选择</Option>
          <Option value="100" v-for="item in sourceList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
    </Row>
    <Row :gutter="8" class="max64" style="margin-bottom: 16px;">
      <Col span="4" >
        <Select  v-model="searchData.businessFromChannel" @on-change="checkAll" placeholder="来源渠道" multiple>
          <Option value="all" >全部选择</Option>
          <Option value="100" v-for="item in channelList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="6">
        <DatePicker class="block" type="datetimerange" split-panels placeholder="商机创建时间" v-model="createDate" format="yyyy-MM-dd HH:mm" @on-change="getCreateDate"></DatePicker>
      </Col>
      <Col span="6">
        <DatePicker class="block" type="datetimerange" split-panels placeholder="截止处理时间" v-model="endHandleDate" format="yyyy-MM-dd HH:mm" @on-change="getEndHandleDate"></DatePicker>
      </Col>
      <Col span="4">
        <Select v-model="searchData.houseTypeFid" placeholder="意向房型">
          <Option value="">请选择</Option>
          <Option v-for="item in houseTypeList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>

      <Col span="4">
        <Select v-model="searchData.isLook" placeholder="是否带看">
          <Option value="">请选择</Option>
          <Option v-for="item in isLookList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
    </Row>
    <Row :gutter="8" class="max64">
      <Col span="5">
      <DatePicker class="block" type="datetimerange" split-panels placeholder="最新跟进时间" v-model="newestFollowDate" format="yyyy-MM-dd HH:mm" @on-change="getNewestFollowDate"></DatePicker>
      </Col>
      <Col span="4" >
      <Input placeholder="请输入客户姓名或电话" v-model="searchData.customerInfo" @keyup.enter.native="findData"></Input>
      </Col>

      <Col span="3">
        <Select v-model="searchData.callStatus" placeholder="通话状态">
          <Option value="">请选择</Option>
          <Option value="100" v-for="item in callStatus" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="4">
        <Select v-model="searchData.loseOrderReason" placeholder="丢单原因">
          <Option value="">请选择</Option>
          <Option value="100" v-for="item in loseReasonList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>

      <Col span="4">
        <Select v-model="searchData.isSeen" placeholder="是否看过直播看房">
          <Option value="">请选择</Option>
          <Option :value=1>是</Option>
          <Option :value=0>否</Option>
        </Select>
      </Col>

      <Col span="4">
        <Select v-model="searchData.customerType" placeholder="客户类型">
          <Option value="">请选择</Option>
          <Option v-for="item in enumList?enumList.customerType:[]" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>

    </Row>

  </search-group>
</template>

<script type="text/ecmascript-6">
  import {getProjects, getProjectZos} from 'api/common'
  import SearchGroup from 'components/SearchGroup/index';
  import {getHouseType} from "api/house";
  import {deepClone, formatDateTimeExceptSecond, formatDateTime} from '@/utils/format';

  export default {
    created() {
      if (this.$route.params.customerInfo) {
        this.searchData.customerInfo = this.$route.params.customerInfo
      }

    },
    props: {
      enumList:{
        type:Object,
        default:null
      },
      statusList: {
        type: Array,
        default(){
          return []
        }
      },
      sourceList: {
        type: Array,
        default(){
          return []
        }
      },
      projectList: {
        type: Array,
        default(){
          return []
        }
      },
      channelList: {
        type: Array,
        default(){
          return []
        }
      },
      gradeList: {
        type: Array,
        default(){
          return []
        }
      },
      loseReasonList: {
        type: Array,
        default: () => {
          return []
        },
      },
      isLookList: {
        type: Array,
        default: () => {
          return []
        },
      },
      callStatus: {
        type: Array,
        default: () => {
          return []
        },
      }

    },
    watch: {
      projectList(val) {
        if (val && val.length) {
          this.searchData.projectFid = val[0].value
          if (this.$route.params.projectFid) {
            this.searchData.projectFid = this.$route.params.projectFid;
          }
        }
      }

    },
    components: {
      SearchGroup
    },

    data() {
      return {
        loading: false,
        searchData: {
          customerType:'',
          callStatus:'',
          projectFid: '',
          zoFid: '',
          houseTypeFid: '',
          handleStatus: '',
          businessFromPlatform: '',
          businessFromChannel: [],
          createTimeFrom: '',
          createTimeTo: '',
          businessEndHandleTimeF: '',
          businessEndHandleTimeT: '',
          newestFollowTimeF:'',
          newestFollowTimeT:'',
          customerInfo: '',
          isLook: '',
          loseReason:'',
          loseOrderReason:'',
          page: 1,
          limit: 10,
          isSeen:'',
          gradeList: []
        },
        // projectList:[],
        zoList: [],
        houseTypeList: [],
        createDate:[],
        endHandleDate:[],
        newestFollowDate:[],
        customerInfoList: [],
        disabledTime: {
          disabledDate(date) {
            return date && date.valueOf() > Date.now();
          }
        },
        selectedAll: false,
        selectedGradeAll: false
      }
    },
    methods: {
      findData() {
        // console.log(this.searchData)
        this.$emit('findData', this.searchData);
      },
      getCreateDate(val){
        this.searchData.createTimeFrom = val[0]
        this.searchData.createTimeTo = val[1]
      },
      getEndHandleDate(val){
        this.searchData.businessEndHandleTimeF = val[0]
        this.searchData.businessEndHandleTimeT = val[1]
      },
      getNewestFollowDate(val){
        this.searchData.newestFollowTimeF = val[0]
        this.searchData.newestFollowTimeT = val[1]
      },
      getProjectZos(projectFid) {

        getProjectZos(projectFid).then(res => {
          this.zoList = res.data
        })
      },
      getHouseTypeListByProFid(projectFid) {

        getHouseType(projectFid).then(res => {
          this.houseTypeList = res.data.houseTypeList
        })
      },
      clearValue() {
        for (const key in this.searchData) {
          if (key === 'page' || key === 'limit' || key === 'projectFid') continue
          if(key === 'businessFromChannel' || key === 'gradeList'){this.searchData[key] = []
          } else { this.searchData[key] = ''}
          this.createDate = []
          this.endHandleDate = []
          this.newestFollowDate = []
          this.selectedAll = false
          this.selectedGradeAll = false
        }
      },
      changeProject(value) {
        if (value !== '') {
          this.getProjectZos(value)
          this.getHouseTypeListByProFid(value)
        } else {
          this.zoList = []
          this.houseTypeList = []
        }
      },
      checkAll(){
        let isCheck = false;
        for (const property in this.searchData.businessFromChannel){
          if(this.searchData.businessFromChannel[property] === 'all'){
            isCheck = true
            this.selectedAll = !this.selectedAll
          }
        }
        if(isCheck && this.selectedAll){
          const values = [];
          for (const property in this.channelList){
            values.push(this.channelList[property].value);
          }
          this.searchData.businessFromChannel = values
        }
        if(isCheck && !this.selectedAll){
          this.searchData.businessFromChannel = []
        }
      },
      checkGradeAll () {
        let isCheck = false;
        for (const property in this.searchData.gradeList){
          if(this.searchData.gradeList[property] === 'all'){
            isCheck = true
            this.selectedGradeAll = !this.selectedGradeAll
          }
        }
        if(isCheck && this.selectedGradeAll){
          const values = [];
          for (const property in this.gradeList){
            values.push(this.gradeList[property].text);
          }
          this.searchData.gradeList = values
        }
        if(isCheck && !this.selectedGradeAll){
          this.searchData.gradeList = []
        }
      }
    }
  }
</script>
<style scoped>
  .input{
    display: inline-block;
    width: 300px;
    margin-right: 20px;
  }

  .dash {
    text-align: center;
  }

  .dash span {
    display: inline-block;
    width: 60%;
    height: 2px;
    background: #dddee1;
    vertical-align: sub;
  }
  .block {
    display: block;
  }
  /* .ivu-col {
  } */

  .date-picker .ivu-col {
    margin-bottom: 0
  }

</style>

